import apiUrl from '../../../../constants';
import axios from 'axios';
import Paginate from 'vuejs-paginate';
import VueElementLoading from 'vue-element-loading';
import moment from 'moment';
import {
	BasicSelect
} from 'vue-search-select'
import DatePicker from 'vue2-datepicker'

export default {
	name: 'shipmentdetails',
	components: {
		BasicSelect,
		Paginate,
		VueElementLoading,
		DatePicker
	},
	props: ['KENGIC_API_KEY', 'hubid'],
	data() {
		return {
			showShipmentDetailsModal: false,
			manifestName: '',
			ManifestDatalist: [
				{
					value: 1,
					text: "APIManifest"
				}, {
					value: 2,
					text: "InBound"
				}, {
					value: 3,
					text: "SupplierManifest"
				},
				{
					value: 4,
					text: "SecondaryInScan"
				},
				{
					value: 5,
					text: "FS"
				}
			],
			shipmentno: '',
			destinationhublist: [],
			manifestData: {
				text: '',
				value: ''
			},
			hubLoading: '',
			SQSName: '',
			shipmentDetailsList: [],
			hubid: '',
			fromdate: '',
			todate: '',
			totalShipments: '',
			isLoading: false
		}
	},
	computed: {},
	filters: {
		moment: function (date) {
			if (date == null || date == '')
				return '--'
			return moment(date).format('DD-MM-YYYY HH:mm:ss');
		},
		toFixedNum: function (val) {
			if (val && val > 0) {
				return Number(parseFloat(val).toFixed(2));
			} else {
				return 0;
			}
		},
	},
	mounted() { },
	methods: {
		SelectManifestData(obj) {
			this.manifestData = obj
			this.manifestName = obj.text
		},
		dateFormat(date) {
			return moment(date).format('YYYY-MM-DD HH:mm:ss');
		},
		getShipmentList() {
			this.showShipmentDetailsModal = false,
				this.isLoading = true,
				this.input = ({
					"DataForm": this.manifestName,
					"FromDate": this.dateFormat(this.fromdate),
					"ToDate": this.dateFormat(this.todate),
					"sorterHubLocation": this.hubid
				})
			axios({
				method: 'POST',
				url: apiUrl.api_url_hubops + 'pushShipmentDataForKengicSorter',
				data: this.input,
				headers: {
					'authorization': "authkey xB84JJ89Hd25"
				}
			})
				.then(result => {
					if (result.data.ResultCode == 100) {
						this.isLoading = false;
						this.shipmentDetailsList = result.data.ResponseData;
						this.totalShipments = this.shipmentDetailsList.length;
						this.showShipmentDetailsModal = true;
						this.$alertify.success(result.data.ReturnMessage)
					} else {
						this.isLoading = false;
						this.pageCount = 0;
						this.shipmentDetailsList = [];
						this.$alertify.error(result.data.ReturnMessage)
					}
				}, error => {
					this.isLoading = false
					console.error(error)
				})
		},
		resetflt() {
			this.isLoading = false,
				this.shipmentDetailsList = [],
				this.fromdate = '',
				this.todate = '',
				this.shipmentno = '',
				this.manifestName = '',
				this.manifestData = {
					text: '',
					value: '',
				},
				this.showShipmentDetailsModal = false,
				this.fromdate = '',
				this.todate = '',
				this.$validator.reset(),
				this.totalShipments = ''
		},
		onSubmitflt: function () {
			this.$validator.validateAll().then((result) => {
				if (!result) {
					return false
				} else {
					this.getShipmentList();
				}
			}).catch(() => {
				console.log('errors exist')
			});
		},
	}
}



// WEBPACK FOOTER //
// ./src/views/components/KengicSorter/pushShipmentDataNew/pushShipmentDataNew.js